import { createRoute } from "@tanstack/solid-router";
import { chronosRoute } from "../chronos";
import { PageContainer, PageHeader } from "@fleet/ui";
import { ActivityTimelineView } from "@/features/chronos-sync/components/activity-timeline-view";
import { Clock } from "@fleet/icons";
import { msg } from "@lingui/core/macro";
import { useI18n } from "@/providers/i18n-provider";
import { AppErrorBoundary } from "@/components/ui/error-boundary";

function ChronosTimelinePage() {
  const { t } = useI18n();
  return (
    <PageContainer
      maxWidth="5xl"
      class="space-y-8"
      containerClass="bg-[#000000] text-white pb-[calc(5.5rem+var(--safe-area-inset-bottom))]"
    >
      <PageHeader
        title={t(msg`Activity Timeline`)}
        description={t(msg`Manual activity log and window tracker history.`)}
        icon={Clock}
      />
      <div class="max-w-4xl mx-auto w-full">
        <AppErrorBoundary
          variant="region"
          label="timeline"
          title={t(msg`The timeline failed to load`)}
          description={t(msg`We could not render your activity history. Try again.`)}
        >
          <ActivityTimelineView />
        </AppErrorBoundary>
      </div>
    </PageContainer>
  );
}

// Deep links for time-entry dialogs (see ActivityTimelineView):
// ?dialog=entry-new | ?dialog=entry-edit&id=<entryId> | ?confirm=delete-entry&id=<entryId>
interface TimelineSearch {
  dialog?: "entry-new" | "entry-edit";
  confirm?: "delete-entry";
  id?: string;
}

const isStr = (v: unknown): v is string => typeof v === "string" && v.trim() !== "";

export function validateTimelineSearch(raw: Record<string, unknown>): TimelineSearch {
  const dialog = raw.dialog === "entry-new" || raw.dialog === "entry-edit" ? raw.dialog : undefined;
  const confirm = raw.confirm === "delete-entry" ? raw.confirm : undefined;
  return {
    dialog,
    confirm,
    id: (dialog === "entry-edit" || confirm) && isStr(raw.id) ? raw.id : undefined,
  };
}

export const chronosTimelineRoute = createRoute({
  getParentRoute: () => chronosRoute,
  path: "/timeline",
  validateSearch: validateTimelineSearch,
  component: ChronosTimelinePage,
});
